import { DropdownService } from './../dropdown.service';
import { Component, OnInit, Input } from '@angular/core';
import { GearTypes } from 'common-gear';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { Router } from "@angular/router";
import { AppService } from 'common-cloudstudio';

@Component({
  selector: 'app-drop-item',
  templateUrl: './drop-item.component.html',
  styleUrls: ['./drop-item.component.scss']
})
export class DropItemComponent implements OnInit {
  @Input()
  actions: Array<GearTypes.GearDisplayClusterAction> = [];

  _open = [];

  _actionTypes = {
    Simple: GearTypes.GearDisplayClusterActionType.Simple,
    HorizontalSlider: GearTypes.GearDisplayClusterActionType.HorizontalSlider,
    VerticalSlider: GearTypes.GearDisplayClusterActionType.VerticalSlider,
    WatchVideoFeed: GearTypes.GearDisplayClusterActionType.WatchVideoFeed,
  };

  constructor(
    private dropdownService: DropdownService,
    private _router: Router,
    public appService: AppService
  ) {}

  ngOnInit() {}

  execAction(action: GearTypes.GearDisplayClusterAction, e, pos) {
    let type = action.ActionType;
    let id: string = action.ActionID;
    let hasChildren  = action.ChildActions;
    let isRange: boolean = type === this._actionTypes.HorizontalSlider || type === this._actionTypes.VerticalSlider;

    if (hasChildren || (isRange && ! e.target.value)) {
      e.stopPropagation();
      return;
    } else if(type === this._actionTypes.WatchVideoFeed) {
      this._router.navigate(['/', {outlets: {modal: ['camera', btoa(action.URL)]}}]);
    } else {
      if(isRange)
        type = e.target.value;
      
      this.dropdownService.execAction({ id: id, type: type, action: action });
    }
  }

  changeItemStatus(data: boolean, id: number, dropdown: BsDropdownModule) {   
    if( ! data)
      return;

    this._open.forEach((x, index) => {
      if(index !== id)
        x.hide();
    })

    this._open[id] = dropdown;
  }
}
